import { Component, OnInit } from "@angular/core";
import { ToastrService } from "ngx-toastr";
import { NgxSpinnerService } from "ngx-spinner";
import { PackageService } from "./package.service";
import * as XLSX from "xlsx";
import { ModalDismissReasons, NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { AddPackageService } from "../add-package/add-package.service";
import { Router } from "@angular/router";
// import { WebSocketService } from '../web-socket.service'
@Component({
  selector: "app-package",
  templateUrl: "./package.component.html",
  styleUrls: ["./package.component.sass"],
})
export class PackageComponent implements OnInit {
  closeResult: string;
  page: number = 0;
  itemsPerPage = 5;
  totalItems: any;

  date;
  searchText: any;

  allPackagesList: any;
  packageId = "";
  senderId = "";
  senderName = "";
  receiverName = "";
  senderMobile = "";
  receiverMobile = "";
  senderEmail = "";
  receiverEmail = "";
  senderAddress = "";
  receiverAddress = "";
  senderLatitude = "";
  senderLongtitude = "";
  receiverLatitude = "";
  receiverLongtitude = "";
  country = "";
  state = "";
  city = "";
  shipmentType = "";
  distance = "";
  packageDesc = "";
  nosPackage = "";
  packageDeliveryPrice = "";
  packageWeight = "";
  driverTip = "";
  specialInstructions = "";
  isSendBySMS = true;
  isSendByEMAIL = false;
  directionsService: any;
  directionsRenderer: any;
  searchBy = "";
  localDate;
  constructor(
    private toastr: ToastrService,
    private spinner: NgxSpinnerService,
    private packageService: PackageService,
    private addPackageService: AddPackageService,
    private modalService: NgbModal,
    // private webSocketService : WebSocketService,
    private router: Router
  ) {
    this.directionsService = new google.maps.DirectionsService();
    this.directionsRenderer = new google.maps.DirectionsRenderer();
  }

  ngOnInit(): void {
    // this.webSocketService.setupSocketConnection()
    // this.webSocketService.connect()
    // this.webSocketService.fetchMovies();
    // this.webSocketService.onFetchMovies().subscribe((result:any)=>{
    //   console.log(result)
    // })
    this.getAllPackage();
  }
  exportPackagesList:any
  getAllPackage() {
    this.spinner.show();
    let data = {
      perPage: this.itemsPerPage,
      page: 0,
      isDeleted: 0,
    };
    this.packageService.getAllPackage(data).subscribe((result: any) => {
      console.log("Packages ", result);
      this.allPackagesList = result.data;
      this.totalItems = result.totalRecords;
      this.exportPackagesList=result.data
      // console.log("Export ", this.exportPackagesList)
      this.spinner.hide();
    });
  }

  gty(page: any) {
    this.spinner.show();
    let data = {
      perPage: this.itemsPerPage,
      page: this.page - 1,
      isDeleted: 0,
    };
    this.packageService.getAllPackage(data).subscribe((result: any) => {
      this.allPackagesList = result.data;
      this.exportPackagesList=result.data
      console.log("Packages ", this.allPackagesList)
      this.totalItems = result.totalRecords;
      this.spinner.hide();
    });
  }

  allExportPackagesList: any;
  getAllPackagess() {
    this.spinner.show();
    let data = {
      perPage: this.totalItems,
      page: 0,
      isDeleted: 0,
    };
    this.packageService.getAllPackage(data).subscribe((result: any) => {
      this.allExportPackagesList = result.data;
      // console.log("data", this.allExportPackagesList);
      this.totalItems = result.totalRecords;
      this.exportAllToExcel(this.allExportPackagesList);
      this.spinner.hide();
    });
  }

  // applyFilter(filterValue:any){
  //   console.log(filterValue);
  //   let filterValueLower = filterValue.toLowerCase();
  //        if(filterValue === '' ) {
  //            this.allPackagesList=this.allPackagesList_forFilter;
  //        }
  //        else {
  //          this.allPackagesList = this.allPackagesList_forFilter.filter((employee:any) => employee.packageID.toLowerCase().includes(filterValueLower))
  //         }
  // }

  search() {
    if (this.searchText != "") {
      let data = {
        fieldName: this.searchBy,
        searchText: this.searchText,
      };
      this.spinner.show();
      this.packageService.searchPackage(data).subscribe((result: any) => {
        if (result.statusCode == 200) {
          this.spinner.hide();
          this.allPackagesList = result.data;
        } else {
          this.spinner.hide();
          this.toastr.error(result.message);
        }
        console.log(result);
      });
    } else {
      this.toastr.error("Please Fill Search text");
    }
  }

  deletePackage(data: any) {
    let sendData = {
      id: data._id,
      isDeleted: 1,
    };
    this.spinner.show();
    this.packageService.updatePackage(sendData).subscribe((result: any) => {
      if (result.statusCode == 200) {
        this.spinner.hide();
        this.toastr.success("Package Deleted Successfully");
        this.getAllPackage();
      } else {
        this.spinner.hide();
        this.toastr.error(result.message);
      }
    });
  }

  editPackage(editModal, data: any) {
    this.router.navigate(["dashboard/editPackage"], {
      queryParams: { id: data._id },
    });

    // this.openEditModal(editModal);
    this.packageId = data.packageID;
    this.senderId = data._id;
    this.senderName = data.senderName;
    this.receiverName = data.receiverName;
    this.senderMobile = data.senderMobile;
    this.receiverMobile = data.receiverMobile;
    this.senderEmail = data.senderEmail;
    this.receiverEmail = data.receiverEmail;
    this.senderAddress = data.fromAddress;
    this.receiverAddress = data.toAddress;
    this.senderLatitude = data.fromLatitude;
    this.senderLongtitude = data.fromLongitude;
    this.receiverLatitude = data.toLatitude;
    this.receiverLongtitude = data.toLongitude;
    this.country = data.country;
    this.state = data.state;
    this.city = data.city;
    this.shipmentType = data.shipmentType;
    this.distance = data.distance;
    this.packageDesc = data.packageDescription;
    this.nosPackage = data.noOfPackages;
    this.packageDeliveryPrice = data.priceForPackageDelivery;
    this.packageWeight = data.weight;
    this.driverTip = data.driverTip;
    this.specialInstructions = data.specialInstructions;
    this.isSendBySMS = data.sendBySms;
    this.isSendByEMAIL = data.sendByEmail;
  }

  updatePackage() {
    let data = {
      id: this.senderId,
      deviceToken: "",
      fromAddress: this.senderAddress,
      toAddress: this.receiverAddress,
      fromLatitude: this.senderLatitude,
      fromLongitude: this.senderLongtitude,
      toLatitude: this.receiverLatitude,
      toLongitude: this.receiverLongtitude,
      senderName: this.senderName,
      senderMobile: this.senderMobile,
      senderEmail: this.senderEmail,
      receiverName: this.receiverName,
      receiverMobile: this.receiverMobile,
      receiverEmail: this.receiverEmail,
      city: this.city,
      state: this.state,
      country: this.country,
      specialInstructions: this.specialInstructions,
      packageDescription: this.packageDesc,
      shipmentType: this.shipmentType,
      priceForPackageDelivery: this.packageDeliveryPrice,
      sendBySms: this.isSendBySMS,
      sendByEmail: this.isSendByEMAIL,
      noOfPackages: this.nosPackage,
      distance: this.distance,
      driverTip: this.driverTip,
      weight: this.packageWeight,
    };
    this.spinner.show();
    this.packageService.updatePackage(data).subscribe((result: any) => {
      if (result.statusCode == 200) {
        this.getAllPackage();
        this.spinner.hide();
        this.toastr.success(result.message);
        this.modalService.dismissAll();
      } else {
        this.spinner.hide();
        this.toastr.error(result.message);
        this.modalService.dismissAll();
      }
    });
  }

  getSenderAddress(address: any) {
    var country, state, city;
    if (address.address_components.length == 3) {
      (country = address.address_components[2].long_name),
        (state = address.address_components[1].long_name);
      city = address.address_components[0].long_name;
    } else if (address.address_components.length == 4) {
      (country = address.address_components[3].long_name),
        (state = address.address_components[2].long_name);
      city = address.address_components[1].long_name;
    } else if (address.address_components.length == 5) {
      (country = address.address_components[4].long_name),
        (state = address.address_components[3].long_name);
      city = address.address_components[2].long_name;
    } else if (address.address_components.length == 6) {
      (country = address.address_components[4].long_name),
        (state = address.address_components[3].long_name);
      city = address.address_components[2].long_name;
    }
    let sendData = {
      city: city,
      state: state,
      country: country,
    };
    this.spinner.show();
    this.addPackageService
      .checkVerifyCity(sendData)
      .subscribe((result: any) => {
        if (result.statusCode == 200) {
          this.spinner.hide();
          this.senderAddress = address.name;
          this.senderLatitude = address.geometry.location.lat();
          this.senderLongtitude = address.geometry.location.lng();
          console.log("this.senderAddress  ", this.senderAddress);
          this.calculateDistanceBwLatLong();
        } else {
          this.spinner.hide();
          this.toastr.error("City Not Verified");
          this.distance = "";
          this.senderLatitude = "";
          this.senderLongtitude = "";
        }
      });
  }

  getReceiverAddress(address: any) {
    console.log("    this.receiverAddress    ", this.receiverAddress);
    if (address.address_components.length == 3) {
      (this.country = address.address_components[2].long_name),
        (this.state = address.address_components[1].long_name);
      this.city = address.address_components[0].long_name;
    } else if (address.address_components.length == 4) {
      (this.country = address.address_components[3].long_name),
        (this.state = address.address_components[2].long_name);
      this.city = address.address_components[1].long_name;
    } else if (address.address_components.length == 5) {
      (this.country = address.address_components[4].long_name),
        (this.state = address.address_components[3].long_name);
      this.city = address.address_components[2].long_name;
    }
    let sendData = {
      city: this.city,
      state: this.state,
      country: this.country,
    };
    this.spinner.show();
    this.addPackageService
      .checkVerifyCity(sendData)
      .subscribe((result: any) => {
        if (result.statusCode == 200) {
          this.spinner.hide();
          this.receiverAddress = address.name;
          this.receiverLatitude = address.geometry.location.lat();
          this.receiverLongtitude = address.geometry.location.lng();
          this.calculateDistanceBwLatLong();
        } else {
          this.spinner.hide();
          this.toastr.error("City Not Verified");
          this.distance = "";
          this.city = "";
          this.state = "";
          this.country = "";
          this.receiverLatitude = "";
          this.receiverLongtitude = "";
        }
      });
  }

  async calculateDistanceBwLatLong() {
    if (this.senderAddress && this.receiverAddress) {
      this.directionsService
        .route({
          origin: this.senderAddress,
          destination: this.receiverAddress,
          travelMode: "DRIVING",
        })
        .then((response) => {
          this.directionsRenderer.setDirections(response);
          this.distance = response.routes[0].legs[0].distance.text;
        })
        .catch((e) => window.alert("Directions request failed due to "));
    } else {
      this.distance = "";
    }
  }
  toRadians(val) {
    var PI = 3.1415926535;
    return (val / 180.0) * PI;
  }

  exportToExcel() {
    // Filter to include only the required fields for the report
    console.log(this.exportPackagesList)
    const data = this.exportPackagesList.map((item) => ({
      PackageID: item.packageID,
      VehicleType: item.vehicleType,
      SenderName: item.senderName,
      SenderMobile: item.senderMobile,
      RecieverName: item.receiverName,
      RecieverMobile: item.receiverMobile,
      From: item.fromAddress,
      TO: item.toAddress,
      CreatedOn: new Date(item.timestamp * 1000).toLocaleString("en-IN", {
        timeZone: "Asia/Kolkata",
        day: "2-digit",
        month: "short",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
        hour12: true,
      }),
      City: item.city,
      Distance: item.distance,
      PaymentMethod: item.paymentDetails.paymentMethod,
      PaymentStatus:
        item.paymentDetails.status === 0
          ? "Pending"
          : item.paymentDetails.status === 1
          ? "Done"
          : "Unknown",
      AmountByUser: item.paymentDetails.totalAmount,
      AmountToDriver:
        item.tripFareWithoutGST - (item.tripFareWithoutGST * 1) / 100,
    }));

    // Convert the filtered array to a worksheet
    const ws: XLSX.WorkSheet = XLSX.utils.json_to_sheet(data);

    // Generate a workbook and add the worksheet
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Sheet1");

    // Save the file with a more dynamic name if needed
    XLSX.writeFile(wb, "Package Report.xlsx");
  }
  // export all packages data to excel
  exportAllToExcel(array: any) {
    const data = array.map((item) => {
      // Check if paymentDetails exists; otherwise, provide default values
      const paymentDetails = item.paymentDetails || {
        paymentMethod: "N/A",
        status: -1,
        totalAmount: 0,
      };
      return {
        PackageID: item.packageID,
        VehicleType: item.vehicleType,
        SenderName: item.senderName,
        SenderMobile: item.senderMobile,
        ReceiverName: item.receiverName,
        ReceiverMobile: item.receiverMobile,
        From: item.fromAddress,
        To: item.toAddress,
        CreatedOn: new Date(item.timestamp * 1000).toLocaleString("en-IN", {
          timeZone: "Asia/Kolkata",
          day: "2-digit",
          month: "short",
          year: "numeric",
          hour: "2-digit",
          minute: "2-digit",
          hour12: true,
        }),
        City: item.city,
        Distance: item.distance,
        PaymentMethod: paymentDetails.paymentMethod,
        PaymentStatus:
          paymentDetails.status === 0
            ? "Pending"
            : paymentDetails.status === 1
            ? "Completed"
            : "Unknown",
        AmountByUser: paymentDetails.totalAmount,
        AmountToDriver: (item.tripFareWithoutGST ?? 0) * 0.99,
      };
    });

    // Convert the filtered array to a worksheet
    const ws: XLSX.WorkSheet = XLSX.utils.json_to_sheet(data);

    // Generate a workbook and add the worksheet
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Sheet1");

    // Save the file
    XLSX.writeFile(
      wb,
      `All_Packages_Report_${new Date().toISOString().slice(0, 10)}.xlsx`
    );
  }

  openEditModal(content) {
    this.modalService.open(content, { size: "lg" }).result.then(
      (result) => {
        this.closeResult = `Closed with: ${result}`;
      },
      (reason) => {
        this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
      }
    );
  }

  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return "by pressing ESC";
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return "by clicking on a backdrop";
    } else {
      return `with: ${reason}`;
    }
  }

  routeViewDetails(data) {
    this.router.navigate(["dashboard/viewPackageDetails"], {
      queryParams: { id: data._id },
    });
  }

  routeTrackPackage(data) {
    this.router.navigate(["dashboard/trackPackage"], {
      queryParams: { id: data._id },
    });
  }
}
